// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { MODAL_DISPLAYED } from 'actions/modalDisplayed';
import { MODAL_HIDDEN } from 'actions/modalHidden';

import errorMessage from 'consts/errorMessageConsts';

export const initialState = {
  display: false,
  content: undefined,
};

/* eslint-disable default-case, no-param-reassign */
const modalReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;
    switch (type) {
      case MODAL_DISPLAYED:
        draft.display = true;
        draft.content = payload || errorMessage.GENERAL_ERROR_MESSAGE;
        break;
      case MODAL_HIDDEN:
        draft.display = false;
        draft.content = null;
        break;
    }
  });

export default modalReducer;
